import './TextArea.scss';

import { useEffect, useRef, useState } from 'react';

const useAutosizeTextArea = (textAreaRef, value) => {
  useEffect(() => {
    if (textAreaRef) {
      // We need to reset the height momentarily to get the correct scrollHeight for the textarea
      textAreaRef.style.height = '0px';
      const { scrollHeight } = textAreaRef;

      // We then set the height directly, outside of the render loop
      // Trying to set this with state or a ref will product an incorrect value.
      textAreaRef.style.height = `${scrollHeight}px`;
    }
  }, [textAreaRef, value]);
};

export default function TextArea({
  value,
  setValue,
  autoFocus = false,
  placeholder,
}) {
  const textAreaRef = useRef(null);
  const [rows, setRows] = useState(1);

  useEffect(() => {
    if (value) setRows(value.split('\n').length);
  }, []);

  useAutosizeTextArea(textAreaRef.current, value);

  return (
    <textarea
      className="auto-grow-textarea f13 p-0 border-none"
      onChange={(event) => setValue(event?.target?.value)}
      placeholder={placeholder}
      ref={textAreaRef}
      rows={rows}
      value={value}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
    />
  );
}
